module.exports = __webpack_public_path__ + "static/SearchVideoMobileEN-9d5d55ffa56e9652e54071e9e33906ba.mp4";